import React from 'react';
import {Cell, Tooltip, XAxis, YAxis, CartesianGrid, BarChart, Bar, ResponsiveContainer } from 'recharts';



const BarsEventosGovBr = ({data, colors}) => {

  const bardataTooltip = ({active, payload, label,}) => {
        const isVisible = active && payload && payload.length;
    return (
      <div style={{
        visibility: isVisible ? 'visible' : 'hidden',
        background: payload.length>0? colors[payload[0].payload.severity-1]:'lightgrey',
        padding:'10px',
        paddingTop:'5px',
        borderRadius:'10px',
        border: '2px solid grey'
        }}>
        {isVisible && (
          <>
            <p className="label"><b>{`${label} : ${payload[0].value}`}</b></p>
            <p className="intro">{payload[0].payload.description}</p>
            <p>Severity: {payload[0].payload.severity}</p>
          </>
        )}
      </div>
      );
    }
  

  return(<>
            <h4>Eventos Auth GovBR</h4>
            <ResponsiveContainer width="100%" height={200}>

              <BarChart
                data={data}
                >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="event_code" />
                <YAxis type="number" domain={[0, 'dataMax']} allowDataOverflow={true} />
                <Tooltip content={bardataTooltip}/>
                <Bar dataKey={"count"}>
                {data.map((entry, index) => (
                  <Cell key={`cell${index}`} fill={colors[entry.severity-1]}/>
                ))}
                </Bar> 
              </BarChart>
            </ResponsiveContainer>
                </>)}



export default BarsEventosGovBr